export const webClientId = "828205771146-chbs0g21m6gcsurre56jtn9une2iqgio.apps.googleusercontent.com";
